import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export function AboutUs() {
  const { t } = useLang();
  return (
    <section
      id="about"
      className="relative border-t border-primary/10 bg-cream/60 px-6 lg:px-24"
    >
      <div className="container mx-auto py-16 lg:py-24">
        <div className="flex flex-col items-center gap-12 lg:flex-row lg:items-center lg:gap-20">
          {/* Copy */}
          <div className="flex-1">
            <SectionHeader
              eyebrow={t.about.eyebrow}
              title={t.about.title}
            />
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg leading-relaxed text-primary/80">
                {t.about.p1}
              </p>
              <p className="mt-4 text-lg leading-relaxed text-primary/70">
                {t.about.p2}
              </p>
            </Reveal>
          </div>

          {/* Framed image */}
          <Reveal delay={0.15} className="w-full flex-1">
            <div className="corner-frame relative mx-auto w-full overflow-hidden rounded-2xl border border-secondary/40 p-2">
              <img
                alt="Al-Rashad — high quality legal services"
                src="https://images.unsplash.com/photo-1619771766980-368d32e44b82?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyNjI5NjF8MHwxfHNlYXJjaHwxOXx8TGF3JTIwRmlybXxlbnwwfHx8fDE2OTYyMTYxMTN8MA&ixlib=rb-4.0.3&q=80&w=1080"
                className="h-full w-full rounded-xl object-cover"
              />
              <div
                className="pointer-events-none absolute inset-2 rounded-xl"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(5,37,45,0) 55%, rgba(5,37,45,0.3) 100%)",
                }}
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
